<div class="main">
  <h2>Selected</h2>

  <dx-tree-view class="treeview" 
  [width]="'100%'" 
  [searchEnabled]="true" 
  searchMode="contains"
    showCheckBoxesMode="selectAll" 
    selectionMode="multiple" 
    [selectNodesRecursive]="true" 
    [selectByClick]="true"
    (onSelectionChanged)="onSelectionChanged($event)" 
    itemTemplate="itemTemplate"
    (onItemRendered)="onItemRendered($event)" 
    (onContentReady)="onContentReady($event)"
    (onItemContextMenu)="onItemContextMenu($event)">
    <ng-container *dxTemplate="let item of 'itemTemplate'">
      <div class="nodeItem" [class.newItem]="exportNode(item)?.isNew">
        <span [class.excludedItemText]="isExcludedNode(item)">{{item.text}}</span>
        <span [class.implicitItem]="isImplicitNode(item)" [class.excludedItem]="isExcludedNode(item)">
        </span>
      </div>
    </ng-container>
  </dx-tree-view>

  <dx-context-menu [dataSource]="menuItems" target=".treeview .dx-treeview-item"
    (onItemClick)="onContextMenuItemClick($event)" (onShowing)="onShowing($event)"></dx-context-menu>
</div>
